import type React from 'react';

import { observer } from 'mobx-react';

import { useCustomListStore } from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';

import FlatButton from 'bz-core-controls/controls/general/flatButton';
import {
  useMenuPage,
  useMenuStore,
  useParentMenuPage
} from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

export interface IProps {}

const Delete: React.FC<IProps> = observer(() => {
  const menu = useMenuStore();
  const page = useMenuPage();
  const parent = useParentMenuPage();
  const store = useCustomListStore();

  const isMenu: boolean = useComputed(() => {
    return page.items.size > 1;
  }, [page]);

  const onDelete = useAction((): void => {
    menu!.onDelete(page.route, parent.route);
    store.onApply(menu!.onExtract());
  }, [menu, page, parent, store]);

  if (!!isMenu) {
    return null;
  }

  return (
    <FlatButton className="delete !text-[#ff0000]" small={true} label="Delete" onClick={onDelete} />
  );
});

Delete.displayName = 'Delete';

export default Delete;
